import { csx } from '@vtex/admin-ui'

export const styles = {
  fullWidth: csx({
    width: '100%',
  }),
  confirmationTitle: csx({
    fontWeight: 400,
  }),
  modal: csx({
    maxWidth: '23rem',
  }),
  modalFooter: csx({
    display: 'flex',
    justifyContent: 'space-between',
  }),
  modalHeader: csx({
    paddingBottom: '0',
  }),
}
